/* eslint-disable no-prototype-builtins */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-expressions */
import React, { useState, useEffect, useMemo } from 'react';
import {
  Button,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Col,
  Input,
} from 'reactstrap';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import SpinnerCircles from '../../../Spinner/SpinerCircles';
import './portConfigModal.css';
import getObiData from '../../../../containers/epikBoxes/helpers';
import { getEpikBoxData, setPortValues, setSilenceDetect, updateVad, selectBoxDetailsPort, setPortConfigChangesMade, clearPortConfigModalSource } from '../../../../actions/EpikBoxes';
import { sortingEven, sortingOdd, trunkOptions } from '../../constants';
import { changeAction } from '../../../../actions/BoxSessionLogging';
import WarningModal from '../../../WarningModal';
import Toggle from '../../../Toggle';
import InfoPopup from '../../../InfoPopup';
import ConfirmationModal from '../../../ConfirmationModal';
import { isEscene } from '../../../../lib/utils';
import { setSelectedPortConfigTemplate } from '../../../../actions/PortConfig';
import { callApi } from '../../../../lib/api/callApi';
import addNote from '../../../../lib/api/addNote';
import { esceneFromObiValues } from '../../../../utils/constants';
import { getPermissionForComponent } from '../../../../utils/permissionsUtils';

const HVIC_POWER_THRESHOLD_OPTIONS = ['2.5W', '2.0W', '1.5W', '1.0W'];
const HVIC_POWER_THRESHOLD_RULE = {
  name: 'HVICPowerThreshold',
  type: 'dropdown',
  options: HVIC_POWER_THRESHOLD_OPTIONS,
  tooltip: '2.5W (default), 2.0W, 1.5W, and 1.0W',
};

const ToggleRow = ({ title, info, toggleName, toggleValue, onToggleChange, realTimeValue, disabled }) => {
  return (
    <Row className="mb-3 d-flex justify-content-center align-items-center">
      <Col className="d-flex">
        <Label title={title}>{title}</Label>
        <sup>
          <InfoPopup id={info.id} text={info.text} />
        </sup>
      </Col>
      <Col className="d-flex align-items-center justify-content-center">
        <Toggle
          left="Disable"
          right="Enable"
          name={toggleName}
          value={toggleValue}
          disabled={disabled}
          onToggle={() => {
            onToggleChange(!toggleValue)
          }}
        />
      </Col>
      <Col>
        <Label className="d-flex align-items-center justify-content-center">
          {realTimeValue === true || realTimeValue === "true" ? "Enabled" : "Disabled"}
        </Label>
      </Col>
    </Row>
  )
}

// eslint-disable-next-line no-shadow
const PortConfigModal = ({
  isOpen,
  isClose,
  settings,
  // eslint-disable-next-line no-shadow
  setPortValues,
  settingsVadEnable,
  setSilenceDetect,
  updateVad,
  port,
  boxDetails,
  refresh,
  settingsValidationRules,
  changeAction,
  getEpikBoxData, 
  templateConfig,
  selectPort,
  selectedPort,
  selectedPortConfigTemplate,
  setSelectedPortConfigTemplate,
  updateTrunkSelection,
  onTrunckSelection,
  setInbandRouting,
  inbandRouting,
  selectedTrunkOption,
  extraConfigValues,
  isMainModalAction = false,
  numbers,
  user,
  onPortConfigSuccess,
  onPortConfigChangesMade,
  setPortConfigChangesMade,
  portConfigModalSource,
  clearPortConfigModalSource,
}) => {
  const selectedObi = boxDetails.Obis.find(obi => {
    return (
      (obi.port1 && obi.port1.boxPortNumber === port?.boxPortNumber) ||
      (obi.port2 && obi.port2.boxPortNumber === port?.boxPortNumber)
    );
  });
  
  const [showModal, setShowModal] = useState(false);
  const [count, setCount] = useState(10);
  const [start, setStart] = useState(false);
  const [data, setData] = useState([]);
  const [manipulatedData, setManipulatedData] = useState([]);
  const [originalData, setOriginalData] = useState([]); // Store original values when modal opens
  const [originalModemMode, setOriginalModemMode] = useState(null); // Store original modemMode
  const [originalConferenceCall, setOriginalConferenceCall] = useState(null); // Store original conferenceCall
  const [originalT38Enabled, setOriginalT38Enabled] = useState(null); // Store original t38Enabled
  const [originalFaxEnabled, setOriginalFaxEnabled] = useState(null); // Store original faxEnabled
  const [loadApply, setLoadApply] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [valueChange, setValueChange] = useState('');
  const [isValid, setIsValid] = useState(false);
  const [confirmation, setConfirmation] = useState();
  const [vadEnableVal, setVadEnableVal] = useState(isMainModalAction ? selectedObi?.vadEnable : settingsVadEnable)
  const token = localStorage.getItem('jwtToken');
  const [dcLockUpdatePopup, setDcLockUpdatePopup] = useState({ show: false, value: {} });
  const [inbandRoute, setInbandRoute] = useState(numbers?.numberByID?.inbandRouting || false)
  const [selectedTrunkOptions, setSelectedTrunkOptions] = useState(selectedTrunkOption ? selectedTrunkOption?.value : port?.appliedConfigTemplate?.trunkSelection)
  const [trunkValueOnBox,setTrunkValueOnBox] = useState('')
  const [inbandValueOnBox, setInbandValueOnBox] = useState('');

  // const [extraConfigValues, setExtraConfigValues] = useState({})
  const [modemMode, setModemMode] = useState(isMainModalAction ? port?.modemMode || false : selectedPortConfigTemplate?.modemMode || false);
  const [faxEnabled, setFaxEnabled] = useState(isMainModalAction ? port?.faxEnabled || false : selectedPortConfigTemplate?.faxEnabled || false);
  const [t38Enabled, setT38Enabled] = useState(isMainModalAction ? port?.t38Enabled || false : selectedPortConfigTemplate?.t38Enabled || false);
  const [JitterMinDelay, setJitterMinDelay] = useState(isMainModalAction ? port?.JitterMinDelay || 0 : selectedPortConfigTemplate?.JitterMinDelay || 0);
  const [JitterMaxDelay, setJitterMaxDelay] = useState(isMainModalAction ? port?.JitterMaxDelay || 0 : selectedPortConfigTemplate?.JitterMaxDelay || 0);
  const [JitterBufferType, setJitterBufferType] = useState(isMainModalAction ? port?.JitterBufferType || 'Fixed' : selectedPortConfigTemplate?.JitterBufferType || 'Fixed');
  const [JitterBufferDisplay, setJitterBufferDisplay] = useState(isMainModalAction ? port?.showJitterDelay || false : selectedPortConfigTemplate?.showJitterDelay || false);
  const [isEsceneDevice, setIsEsceneDevice] = useState(false);
  const [wayCalling, set3WayCalling] = useState(isMainModalAction ? port?.conferenceCall || false : selectedPortConfigTemplate?.conferenceCall || false);
  const [showEpiConfig, setShowEpiConfig] = useState(false);
  const [originalSilenceDetect, setOriginalSilenceDetect] = useState(null);

  const portConfigurationAccess = getPermissionForComponent('portConfigurationAccess', user?.permissionsGroup);
  const isReadOnly = portConfigurationAccess === 'read';

  const sortFunc = (a, b) => {
    const portIdx = port.boxPortNumber.split(' ')[1];
    const sortingType = portIdx % 2 === 0 ? sortingEven : sortingOdd;
    return sortingType.indexOf(a.id) - sortingType.indexOf(b.id);
  };

  useEffect(() => {
    const divElement = document.getElementById('test-time-remaining');
    const isHidden = divElement.getAttribute('hidden') !== null;
    if (isHidden && isOpen) {
      setDcLockUpdatePopup({ show: true });
    } else {
      setShowModal(isOpen);
    }
    // Reset originalData when modal closes
    if (!isOpen) {
      setOriginalData([]);
      setOriginalModemMode(null);
      setOriginalConferenceCall(null);
      setOriginalT38Enabled(null);
      setOriginalFaxEnabled(null);
    }
  }, [isOpen, clearPortConfigModalSource]);

  useEffect(() => {
    const fetchVswitchInfo = async () => {
      try {
        const vpnAddress = boxDetails?.vpnAddress;
        if (vpnAddress) {
          let endpoint = `boxes/vswitchtab/${vpnAddress}`
          const response = await callApi({
            endpoint,
            method: 'GET',
            isMyEpik: false
          });
          if (response && response.data && response?.data.portsInfo) {
            const matchingPort = response.data.portsInfo.find(
              (portInfo) => portInfo.port === port?.portKey
            );
            if (matchingPort) {
              setTrunkValueOnBox(matchingPort.trunkType);
            } else {
              console.warn('No matching port found in portsInfo.');
            }
          }
        }
      } catch (error) {
        console.error('Error fetching VSwitch info:', error);
      }
    };
    
    const tnDetails = async () => {
      try {
        const vpnAddress = boxDetails?.vpnAddress;
        const numberRef = (port?.assignedNumberRef && port?.assignedNumberRef?._id) || port?.assignedNumberRef
        if (vpnAddress && numberRef) {
          let endpoint = `numbers/${numberRef}/tnDetails`
          const response = await callApi({
            endpoint,
            method: 'GET',
            isMyEpik: false
          });
          if (response && response.data && response?.data) {
              setInbandValueOnBox(response?.data?.data?.tnList?.tnItem[0]?.trunkGroup);

          }
        }
      } catch (error) {
        console.error('Error fetching tnDetails : ', error);
      }
    };
    
    if(port?.appliedConfigTemplate?.showTrunkSelectionToggle)
      fetchVswitchInfo();
    if(port?.appliedConfigTemplate?.showInbandRouteToggle)
      tnDetails();
  }, []);
  

  const fieldsValidation = array => {
    const isAllFieldsValid = array.every(item => item.dbValue !== '' && item.dbValue !== null);
    if (isAllFieldsValid) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  };
  
  const validateRegX = (value, regEx) => {
    if (!value) return false;
    const regExS = new RegExp(regEx);
    return regExS.test(value);
  };

  useEffect(() => {
    setVadEnableVal(isMainModalAction ? selectedObi?.vadEnable : settingsVadEnable)
  }, [selectedObi?.vadEnable, settingsVadEnable])
  

  useEffect(() => {
    settings?.length && settings.sort(sortFunc);
    const newArr = [];
    const obi = getObiData(port.boxPortNumber, boxDetails);

    const esceneDevice = isEscene(obi?.macAddress);

    // Ensure HVICPowerThreshold validation rule exists (Escene devices only)
    const rulesWithHvic = [...(settingsValidationRules || [])];
    if (esceneDevice && !rulesWithHvic.some(r => r.name === 'HVICPowerThreshold')) {
      rulesWithHvic.push(HVIC_POWER_THRESHOLD_RULE);
    }

    // Inject HVICPowerThreshold into settings after OffHookCurrentMax if not present
    let settingsToUse = settings || [];
    if (settingsToUse.length && esceneDevice) {
      const offhookItem = settingsToUse.find(s => s.name && s.name.split('.').pop() === 'OffHookCurrentMax');
      const hvicExists = settingsToUse.some(s => s.name && s.name.split('.').pop() === 'HVICPowerThreshold');
      if (offhookItem && !hvicExists) {
        const baseName = offhookItem.name.includes('.')
          ? offhookItem.name.replace('OffHookCurrentMax', 'HVICPowerThreshold')
          : 'HVICPowerThreshold';
        const hvicItem = {
          ...offhookItem,
          name: baseName,
          dbValue: port?.HVICPowerThreshold || '2.5W',
          value: extraConfigValues?.HVICPowerThreshold ?? '',
        };
        const offhookIdx = settingsToUse.indexOf(offhookItem);
        settingsToUse = [...settingsToUse];
        settingsToUse.splice(offhookIdx + 1, 0, hvicItem);
      }
    }

    settingsToUse.length &&
      settingsToUse.forEach(item => {
        const nameOfInterest = item.name.split('.');

        rulesWithHvic.forEach(i => {
          let dbValue = item.dbValue;
          
          if (
            isEscene(obi?.macAddress) &&
            item.name === 'RingVoltage' &&
            !Object.values(esceneFromObiValues).includes(`${dbValue}`)
          ) {
            dbValue = esceneFromObiValues[dbValue];
          }

          if (i.name === nameOfInterest[nameOfInterest.length - 1]) {
            // HVICPowerThreshold: only show for Escene devices
            if (i.name === 'HVICPowerThreshold' && !esceneDevice) return;

            let dbValue = i.type === "toggle" ? item.dbValue || 'Medium' : item.dbValue || '';
            let portValue = item.value ? item.value : '';

            // HVICPowerThreshold: Database Settings from port, Port Settings from extraConfigValues (no default)
            if (i.name === 'HVICPowerThreshold') {
              dbValue = port?.HVICPowerThreshold || '2.5W';
              portValue = extraConfigValues?.HVICPowerThreshold ?? '';
            }

            // Special handling for RingVoltage on Escene devices
            // Convert actual voltage value to dropdown option if needed
            if (i.name === 'RingVoltage' && i.type === 'dropdown' && dbValue) {
              const obi = getObiData(port.boxPortNumber, boxDetails);
              if (isEscene(obi?.macAddress)) {
                const voltageValue = parseInt(dbValue, 10);
                // If value is an actual voltage (30-80), convert to option (0-5)
                if (voltageValue >= 30 && voltageValue <= 80) {
                  // Find closest match: 30->0, 40->1, 50->2, 60->3, 70->4, 80->5
                  const voltageMap = { 30: '0', 40: '1', 50: '2', 60: '3', 70: '4', 80: '5' };
                  const closestVoltage = Object.keys(voltageMap).reduce((prev, curr) => {
                    return Math.abs(parseInt(curr, 10) - voltageValue) < Math.abs(parseInt(prev, 10) - voltageValue) ? curr : prev;
                  });
                  dbValue = voltageMap[closestVoltage];
                }
                // If value is already a key in esceneFromObiValues, convert it
                else if (esceneFromObiValues[dbValue]) {
                  dbValue = esceneFromObiValues[dbValue];
                }
              }
            }
            
            let isValid = false;
            
            // Determine initial validity
            if (i.type === "toggle") {
              isValid = dbValue === 'Low' || dbValue === 'Medium';
            } else if (i.type === "dropdown") {
              if (i?.options && i.options.length > 0 && dbValue) {
                isValid = i.options.some(opt => {
                  const optStr = String(opt).toLowerCase();
                  const valStr = String(dbValue).toLowerCase();
                  return optStr === valStr;
                });
                // Fallback to regex if not found in options
                if (!isValid && i?.regEx) {
                  isValid = validateRegX(dbValue, i.regEx);
                }
              } else if (dbValue) {
                isValid = true;
              }
            } else if (i?.regEx && dbValue) {
              // Special handling for DTMFPlaybackLevel
              if (i.name === 'DTMFPlaybackLevel') {
                const numValue = parseInt(dbValue, 10);
                if (!isNaN(numValue) && numValue >= -90 && numValue <= 3) {
                  isValid = validateRegX(dbValue, i.regEx);
                } else {
                  isValid = false;
                }
              } else {
                isValid = validateRegX(dbValue, i.regEx);
              }
            } else if (dbValue) {
              isValid = true;
            }
            
            const itemData = {
              ...item,
              ...i,
              dbValue,
              value: i.name === 'HVICPowerThreshold' ? portValue : (item.value ? item.value : ''),
              isValid,
              options: i?.options ? i.options : [],
              ...(i.name === 'HVICPowerThreshold' && { tooltip: '2.5W (default), 2.0W, 1.5W, and 1.0W' }),
            };
            newArr.push(itemData);
          }
        });
      });
    fieldsValidation(newArr);
    setData(newArr);
    setManipulatedData(newArr);
    // Store original data for comparison (only on first load, not on re-renders)
    // This captures the initial state when modal opens
    if (originalData.length === 0 && newArr.length > 0) {
      const originalCopy = JSON.parse(JSON.stringify(newArr)); // Deep copy
      setOriginalData(originalCopy);
      // Store original values for additional state variables
      const initialModemMode = isMainModalAction ? port?.modemMode || false : selectedPortConfigTemplate?.modemMode || false;
      const initialConferenceCall = isMainModalAction ? port?.conferenceCall || false : selectedPortConfigTemplate?.conferenceCall || false;
      const initialT38Enabled = isMainModalAction ? port?.t38Enabled || false : selectedPortConfigTemplate?.t38Enabled || false;
      const initialFaxEnabled = isMainModalAction ? port?.faxEnabled || false : selectedPortConfigTemplate?.faxEnabled || false;
      setOriginalModemMode(initialModemMode);
      setOriginalConferenceCall(initialConferenceCall);
      setOriginalT38Enabled(initialT38Enabled);
      setOriginalFaxEnabled(initialFaxEnabled);
    }
    setIsEsceneDevice(isEscene(obi?.macAddress))
    
    // Capture original silenceDetect value
    const silenceDetectItem = newArr.find(item => item.name.toLowerCase().includes('silence'));
    if (silenceDetectItem && originalSilenceDetect === null) {
      setOriginalSilenceDetect(silenceDetectItem.dbValue);
    }
  }, [settings, port, extraConfigValues]);

  useEffect(() => {
    const index = data.findIndex(item=>item.id==="940393563")
    if (data[index]?.dbValue === null || data[index]?.dbValue === '') {
      const newData = [...data];
      newData[index] = { ...newData[index], dbValue: 'inband', isValid: true };
      setData(newData);
      fieldsValidation(newData);
    } else if (data[index]?.dbValue) {
      const newData = [...data];
      newData[index] = { ...newData[index], isValid: true };
      setData(newData);
      fieldsValidation(newData);
    }
  }, [manipulatedData]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (start && count > 1) {
      const timer = setTimeout(() => setCount(count - 1), 1000);
      if (count - 1 === 1) {
        setTimeout(() => {
          setCount(10);
          setIsLoading(false);
          setStart(false);
        }, 1000);
      }
      return () => {
        clearTimeout(timer);
      };
    }
    setStart(false);
  }, [count, start]);

  const handleChange = (e, item) => {
    if (e.target) {
      const { name, value } = e.target;
      data[name] = { ...data[name], dbValue: value, useDefault: value === '' };
      setData([...data]);
    } else {
      const findIndex = data?.findIndex(item => item.name.toLowerCase().includes('silence'));
      data[findIndex] = { ...data[findIndex], dbValue: !e ? 'Low' : 'Medium' };
      setData([...data]);
    }
  };
  const handleBlur = (e, item) => {
    const validate = item.regEx;
    const { name, value } = e.target;
    const regEx = new RegExp(validate);
    if (value.length >= 1 && !regEx.test(value)) {
      toast.error('Invalid entry');
      setIsValid(false);
      data[name] = { ...data[name], isValid: false };
      setData([...data]);
    } else if (value.length >= 1 && regEx.test(value)) {
      data[name] = { ...data[name], dbValue: value, useDefault: value === '', isValid: true };
      setData([...data]);
      setIsValid(true);
    }
  };

  const isEmpty = value => {
    return (
      // null or undefined
      value == null ||
      // has length and it's zero
      (value.hasOwnProperty('length') && value.length === 0) ||
      // is an Object and has no keys'

      (value.constructor === Object && Object.keys(value).length === 0)
    );
  };

  // apply button
  const copyPortSettingsToDatabase = () => {
    const newData = data.map(item => {
      // Copy port settings (value) to database settings (dbValue)
      let portValue = item.value || '';
      
      // Handle toggle type: normalize to 'Low' or 'Medium'
      if (item.type === 'toggle') {
        const valueLower = String(portValue).toLowerCase().trim();
        // Skip copying if value is an error message
        if (valueLower.includes('unable to fetch') || valueLower.includes('error')) {
          // Don't copy error messages, keep current dbValue
          return item;
        }
        // Normalize toggle values: 'low' -> 'Low', 'medium'/'med' -> 'Medium', default to 'Medium'
        if (valueLower === 'low') {
          portValue = 'Low';
        } else if (valueLower === 'medium' || valueLower === 'med') {
          portValue = 'Medium';
        } else {
          // Default to 'Medium' if value doesn't match expected formats
          portValue = 'Medium';
        }
      }
      
      // Determine if the item is valid based on its type
      let isValid = false;
      if (item.type === 'toggle') {
        isValid = portValue === 'Low' || portValue === 'Medium';
      } else if (item.type === 'dropdown') {
        isValid = portValue && portValue !== '';
        // If options exist, validate against them
        if (isValid && item.options && item.options.length > 0) {
          isValid = item.options.some(opt => opt === portValue || String(opt).toLowerCase() === String(portValue).toLowerCase());
        }
      } else if (item.regEx) {
        isValid = portValue && validateRegX(portValue, item.regEx);
      } else {
        // Items without regEx are valid if they have a value
        isValid = portValue && portValue !== '';
      }
      
      const updatedItem = {
        ...item,
        dbValue: portValue,
        isValid
      };
      return updatedItem;
    });
    setData(newData);
    fieldsValidation(newData);
    
    // Copy extraConfigValues to corresponding state variables
    if (extraConfigValues) {
      // Copy modemMode
      if (extraConfigValues.modemMode !== undefined) {
        const modemModeValue = extraConfigValues.modemMode === 'true' || extraConfigValues.modemMode === true;
        setModemMode(modemModeValue);
      }
      
      // Copy t38Enabled
      if (extraConfigValues.t38Enabled !== undefined) {
        const t38Value = extraConfigValues.t38Enabled === 'true' || extraConfigValues.t38Enabled === true;
        setT38Enabled(t38Value);
      }
      
      // Copy faxEnabled
      if (extraConfigValues.faxEnabled !== undefined) {
        const faxValue = extraConfigValues.faxEnabled === 'true' || extraConfigValues.faxEnabled === true;
        setFaxEnabled(faxValue);
      }
      
      // Copy JitterMinDelay
      if (extraConfigValues.JitterMinDelay !== undefined) {
        const jitterMin = parseInt(extraConfigValues.JitterMinDelay, 10) || 0;
        setJitterMinDelay(jitterMin);
      }
      
      // Copy JitterMaxDelay
      if (extraConfigValues.JitterMaxDelay !== undefined) {
        const jitterMax = parseInt(extraConfigValues.JitterMaxDelay, 10) || 0;
        setJitterMaxDelay(jitterMax);
      }
      
      // Copy JitterBufferType
      if (extraConfigValues.JitterBufferType !== undefined) {
        setJitterBufferType(extraConfigValues.JitterBufferType);
      }
      
      // Copy ThreeWayCalling (conferenceCall)
      if (extraConfigValues.ThreeWayCalling !== undefined) {
        const threeWayValue = extraConfigValues.ThreeWayCalling === 'true' || extraConfigValues.ThreeWayCalling === true;
        set3WayCalling(threeWayValue);
      }
    }
    
    toast.success('Port settings copied to database settings');
  };

  const onApplyButton = () => {
    if (isReadOnly) return;
    const anyFieldEmpty = data.some(item => item.dbValue === '' || item.dbValue === null);
    if (anyFieldEmpty) {
      const emptyItems = data.filter(item => item.dbValue === '' || item.dbValue === null);
      console.log('Empty items:', emptyItems.map(item => ({ name: item.name, dbValue: item.dbValue })));
      return toast.error('Please fill all fields');
    }

    // Re-validate all items before checking
    const validatedData = data.map(item => {
      let isValid = false;
      
      // Skip validation if dbValue is empty or null (already checked above)
      if (!item.dbValue || item.dbValue === '' || item.dbValue === null) {
        return { ...item, isValid: false };
      }
      
      // Toggle items are valid if value is 'Low' or 'Medium'
      if (item.type === 'toggle') {
        isValid = item.dbValue === 'Low' || item.dbValue === 'Medium';
      } 
      // Dropdown items: check if value exists in options if options are provided
      else if (item.type === 'dropdown') {
        if (item.options && item.options.length > 0) {
          let valueToCheck = item.dbValue;
          
          // Special handling for RingVoltage on Escene devices
          // Convert actual voltage value (30, 40, 50, 60, 70, 80) to dropdown option (0-5)
          if (item.name === 'RingVoltage' && isEsceneDevice) {
            const obi = getObiData(port.boxPortNumber, boxDetails);
            if (isEscene(obi?.macAddress)) {
              // Check if value is an actual voltage (30-80) and convert to option
              const voltageValue = parseInt(valueToCheck, 10);
              if (voltageValue >= 30 && voltageValue <= 80) {
                // Find the closest option: 30->0, 40->1, 50->2, 60->3, 70->4, 80->5
                const optionMap = { 30: '0', 40: '1', 50: '2', 60: '3', 70: '4', 80: '5' };
                // Find closest match
                const closestVoltage = Object.keys(optionMap).reduce((prev, curr) => {
                  return Math.abs(parseInt(curr, 10) - voltageValue) < Math.abs(parseInt(prev, 10) - voltageValue) ? curr : prev;
                });
                valueToCheck = optionMap[closestVoltage];
              }
              // If value is already in esceneFromObiValues, convert it
              if (esceneFromObiValues[valueToCheck]) {
                valueToCheck = esceneFromObiValues[valueToCheck];
              }
            }
          }
          
          // Check if value matches any option (case-insensitive)
          isValid = item.options.some(opt => {
            const optStr = String(opt).toLowerCase();
            const valStr = String(valueToCheck).toLowerCase();
            return optStr === valStr;
          });
          // If not found in options but has regEx, try regex validation as fallback
          if (!isValid && item.regEx) {
            isValid = validateRegX(valueToCheck, item.regEx);
          }
        } else {
          // No options provided, just check if value exists
          isValid = true;
        }
      }
      // Items with regEx need to pass regex validation
      else if (item.regEx) {
        // Special case: DTMFPlaybackLevel might have port setting values that are out of range
        // If the value doesn't match regex but is a valid number, check if it's within reasonable bounds
        if (item.name === 'DTMFPlaybackLevel') {
          const numValue = parseInt(item.dbValue, 10);
          // Check if it's a valid number and within the expected range (-90 to 3)
          if (!isNaN(numValue) && numValue >= -90 && numValue <= 3) {
            isValid = validateRegX(item.dbValue, item.regEx);
          } else {
            // If value is out of range, it's invalid
            isValid = false;
          }
        } else {
          isValid = validateRegX(item.dbValue, item.regEx);
        }
      }
      // Items without regEx and not toggle/dropdown are valid if they have a value
      else {
        isValid = true;
      }
      
      return { ...item, isValid };
    });
    
    // Update data with validated items
    setData(validatedData);
    
    const everyThingValid = validatedData.every(item => item.isValid);

    if (!everyThingValid && !showEpiConfig) {
      // Find invalid items for debugging
      const invalidItems = validatedData.filter(item => !item.isValid);
      console.log('Invalid items:', invalidItems.map(item => ({ 
        name: item.name, 
        dbValue: item.dbValue, 
        type: item.type,
        regEx: item.regEx,
        options: item.options
      })));
      
      // Create error message with invalid field names
      const invalidFieldNames = invalidItems.map(item => itemsName(item)).join(', ');
      const errorMessage = invalidItems.length === 1 
        ? `Invalid entry in field: ${invalidFieldNames}`
        : `Invalid entries in fields: ${invalidFieldNames}`;
      
      return toast.error(errorMessage);
    }

    setConfirmation({
      ata:
        'The ATA needs to be rebooted to configure the port and the affected ports will be offline for 3 minutes. Are you sure you want to proceed?',
    });
  };

  const onConfirm = () => {
    setConfirmation({
      ata:
        'The ATA needs to be rebooted to configure the port and the affected ports will be offline for 3 minutes. Are you sure you want to proceed?',
    });

    setConfirmation();
    onApply();
  };

  const onApply = async () => {
    // Capture the modal source at the start, before any async operations that might clear it
    const modalSource = portConfigModalSource;
    const dataSettings = [...data];
    setIsLoading(true);
    setLoadApply(true);
    // const settingsOfInterest = data.map(item => {
    //   const itemOfInterest = { ...item };
    //   return { ...itemOfInterest };
    // });
    const obi = getObiData(port.boxPortNumber, boxDetails);

    const modeModeVal = { name: 'modemMode', dbValue: modemMode }
    const conferenceCall = { name: 'conferenceCall', dbValue: wayCalling }
    const t38EnableVal = { name: 't38Enabled', dbValue: t38Enabled }
    const faxEnableVal = { name: 'faxEnabled', dbValue: faxEnabled }
    const modemOnlyVal = { name: 'modemOnly', dbValue: selectedPortConfigTemplate?.modemOnly || false } // not visible on UI yet
    
    // Only add Jitter Buffer settings if EPI Configuration mode is active
    if (showEpiConfig) {
      const JitterMinDelayVal = { name: 'JitterMinDelay', dbValue: JitterMinDelay }
      const JitterMaxDelayVal = { name: 'JitterMaxDelay', dbValue: JitterMaxDelay }
      const JitterBufferTypeVal = { name: 'JitterBufferType', dbValue: JitterBufferType }
      dataSettings.push(JitterMinDelayVal)
      dataSettings.push(JitterMaxDelayVal);
      dataSettings.push(JitterBufferTypeVal);
    }
    
    dataSettings.push(modeModeVal);
    dataSettings.push(t38EnableVal);
    dataSettings.push(faxEnableVal);
    dataSettings.push(modemOnlyVal);
    dataSettings.push(conferenceCall);

    // HVICPowerThreshold: use minimal payload { name, dbValue } and place at end
    const hvicIndex = isEsceneDevice ? dataSettings.findIndex(item => item.name === 'HVICPowerThreshold') : -1;
    if (hvicIndex >= 0) {
      const hvicDbValue = dataSettings[hvicIndex].dbValue;
      dataSettings.splice(hvicIndex, 1);
      dataSettings.push({ name: 'HVICPowerThreshold', dbValue: hvicDbValue });
    }

    console.log('dataSettings', dataSettings);
    // return

    let emptyAlert = false;
    dataSettings.forEach(item => {
      return isEmpty(item.dbValue) && (emptyAlert = true);
    });
    if (!emptyAlert) {
      const findIndex = dataSettings?.findIndex(item =>
        item.name.toLowerCase().includes('silence'),
      );
      const portIdx = port.boxPortNumber.split(' ')[1];
      const portNum = portIdx % 2 === 0 ? 2 : 1;
      
      // Only send silenceDetect request if the value has changed
      let silenceDetect = true; // Default to success if no change
      if (findIndex !== -1 && dataSettings[findIndex].dbValue !== originalSilenceDetect) {
        const toggle = dataSettings[findIndex].dbValue === 'Low' ? 'enable' : 'disable';
        silenceDetect = await setSilenceDetect(token, obi._id, portNum, toggle);
      }
      
      // Only update VAD if EPI Configuration mode is active
      if (showEpiConfig) {
        await updateVad(token, obi._id, vadEnableVal, true);
      }
  
      if (!silenceDetect) {
        dataSettings[findIndex] = {
          ...dataSettings[findIndex],
          dbValue: dataSettings[findIndex].dbValue === 'Low' ? 'Medium' : 'Low',
        };
      }
      // dataSettings['']
      const body = {
        device: obi.deviceId,
        settings: { settings: dataSettings },
      };
      let apiCallSucceeded = false;
      try {
        const portResStatus = await setPortValues(token, obi._id, body);
       
        // API returns data object on success, or false on error
        // If portResStatus is truthy (not false), the API call succeeded
        if (portResStatus && portResStatus !== false) {
          apiCallSucceeded = true;
          
          // Try to extract updatedObi if it exists in the response
          const { rebootStatus, updatedObi } = portResStatus || {};
          if (updatedObi) {
            const updatedPort = updatedObi[`port${portNum}`]
          }
          
          if (rebootStatus === 'failed') {
            toast.warning('Configuration updated, but reboot failed. Please try rebooting manually.');
          }
        }

        await updateTrunkSelection(selectedTrunkOptions);
        await onTrunckSelection(selectedTrunkOptions);
        await setInbandRouting(inbandRoute);
        const updatedBox = await getEpikBoxData(token, boxDetails._id);
        const updatedObi = getObiData(port.boxPortNumber, updatedBox);
        const updatedPort = updatedObi[`port${portNum}`];
        
        selectPort({ ...selectedPort, ...updatedPort });
        
        if (modalSource === 'portConfigButton') {
          setPortConfigChangesMade(true);
          
          // Notify parent that port configuration changes were made
          if (onPortConfigChangesMade) {
            try {
              onPortConfigChangesMade(true);
            } catch (error) {
              console.error('PortConfigModal: Error calling onPortConfigChangesMade:', error);
            }
          }
        }
        
        if (onPortConfigSuccess) {
          setShowModal(false);
          isClose(); 
          setTimeout(() => {
            try {
              onPortConfigSuccess();
            } catch (error) {
              console.error('PortConfigModal: Error executing onPortConfigSuccess callback:', error);
            }
          }, 200);
          return;
        }
        
        if (apiCallSucceeded) {
          setShowModal(false);
          setTimeout(() => {
            isClose();
          }, 100);
        }
      } catch (error) {
        console.error('Error applying configuration:', error);
        toast.error('An error occurred while applying configuration.');
        
        if (modalSource === 'portConfigButton') {
          setPortConfigChangesMade(true);
          
          if (onPortConfigChangesMade) {
            try {
              onPortConfigChangesMade(true);
            } catch (err) {
              console.error('PortConfigModal: Error calling onPortConfigChangesMade:', err);
            }
          }
        }
      } finally {
        setLoadApply(false);
        setIsLoading(false);
      }
    }
  };

  const unLockBoxButton = async () => {
    const element = document.getElementById('test-lock-icon');
    if (element) {
      // Simulate a click event
      element.click();
    } else {
      console.error('Element with id "test-lock-icon" not found.');
    }
  };

  const itemsName = item => {
    if (item.name === 'OnHookTipRingVoltage') return 'Onhook Volts';
    if (item.name === 'DTMFMethod') return 'DTMF Method';
    if (item.name === 'ChannelRxGain') return 'RX Gain';
    if (item.name === 'ChannelTxGain') return 'TX Gain';
    if (item.name === 'DTMFDetectMinLength') return 'DTMF Detect Length';
    if (item.name === 'OffHookCurrentMax') return 'Offhook Current';
    if (item.name === 'HVICPowerThreshold') return 'HVIC Power Threshold';
    if (item.name === 'DTMFDetectMinGap') return 'DTMF Detect Gap';
    if (item.name === 'DTMFPlaybackLevel') return 'DTMF Playback Level';
    if (item.name === 'RingVoltage') return 'Ring Voltage';
    if (item.name === 'DigitMapShortTimer') return 'Digit Map Short Timer';
    if (item.name === 'SilenceDetectSensitivity') return 'Silence Detect';
    if (item.name === 'CPCDelayTime') return 'CPC Delay Time (in milliseconds)';
    if (item.name === 'CPCDuration') return 'CPC Duration (in milliseconds)';
    return item.name;
  };

  const getTrunkLabel = (trunkValueOnBox) => {
    if(trunkValueOnBox == 1)
      trunkValueOnBox = 'b'
    const matchingOption = trunkOptions.find(option => option.value === trunkValueOnBox);
    return matchingOption ? matchingOption.label : 'Unknown'; 
  };
  const renderItem = (item, ind) => {
    if (item.type === 'dropdown') {
      return (
        <Input
          disabled={isLoading || isReadOnly}
          type="select"
          name={ind}
          onChange={ev => handleChange(ev, item)}
          onBlur={ev => handleBlur(ev, item)}
        >
          {item.options.map((el, key) => {
            let dbValue= item.dbValue;
            const obi = getObiData(port.boxPortNumber, boxDetails);
            item.name==='RingVoltage' && console.log('item.dbvalues ', item.dbValue)
           if(
            isEscene(obi?.macAddress) && 
            item.name==='RingVoltage' &&
            !Object.values(esceneFromObiValues).includes(`${dbValue}`) 
          ){
            console.log(dbValue," value is transformed" )
            dbValue = esceneFromObiValues[dbValue]
           }
            const selectedValues =  `${dbValue}`?.toLowerCase() === `${el}`?.toLowerCase()
            const label = (isEscene(obi?.macAddress) && item?.name === 'RingVoltage') ? esceneToObiValues[el] : el
            // const label =  el
            return (
              <option key={el+key}
                value={ el}
                selected={selectedValues}
              >
              {label}
            </option>
            )
          }
          )}
        </Input>
      );
    }
    if (item.type === 'toggle') {
      console.log('item.dbValue', item.dbValue);
      return (
        <Toggle
          left="Med"
          right="Low"
          value={item.dbValue === 'Low'}
          disabled={isReadOnly}
          onToggle={value => handleChange(value)}
        />
      );
    }
    return (
      <Input
        disabled={isLoading || isReadOnly}
        name={ind}
        value={item.dbValue}
        onChange={ev => handleChange(ev, item.regEx)}
        onBlur={ev => handleBlur(ev, item)}
        valid={item.dbValue.length > 0 && item.isValid}
      />
    );
  };

  const esceneToObiValues = {
    0: '30',
    1: '40',
    2: '50',
    3: '60',
    4: '70',
    5: '80'
  };

  const { ata } = confirmation || {};


  return (
    <>
    <Modal isOpen={showModal} style={{ maxWidth: '600px' }}>
      <ModalHeader tag="div" className="p-3 pri-case-modal-header">
        <div className="d-flex justify-content-between align-items-center w-100">
          <h5 className="modal-title mb-0">{showEpiConfig ? "EPI Configuration" : "Port Configuration"}</h5>
          {isEsceneDevice && !isReadOnly && (
            <Button
              color={showEpiConfig ? "primary" : "outline-primary"}
              size="sm"
              onClick={() => setShowEpiConfig(!showEpiConfig)}
            >
              {showEpiConfig ? "Port Configuration" : "EPI Configuration"}
            </Button>
          )}
        </div>
      </ModalHeader>
      <ModalBody>
        {showEpiConfig && isEsceneDevice ? (
          // EPI Configuration Mode - Show only VAD and Jitter Buffer settings
          <>
            <Row className="mb-2">
              <Col />
              <Col>
                <h1 className="font-weight-bold">Database Settings</h1>
              </Col>
              <Col>
                <h1 className="font-weight-bold">EPI Settings</h1>
              </Col>
            </Row>
            {/* VAD Setting */}
            <Row className="mb-3 d-flex justify-content-center align-items-center">
              <Col className="d-flex">
                <Label title='SET VAD enable/disable'>VAD</Label>
                <sup>
                  <InfoPopup id={'VAD'} text={'SET VAD enable/disable'} />
                </sup>
              </Col>
              <Col className="d-flex align-items-center justify-content-center">
                <Toggle
                  left="Disable"
                  right="Enable"
                  name="vad"
                  value={vadEnableVal}
                  disabled={isReadOnly}
                  onToggle={value => setVadEnableVal(!value)}
                />
              </Col>
              <Col>
                <Label className="d-flex align-items-center justify-content-center">
                  {settingsVadEnable ? "Enabled" : "Disabled"}
                </Label>
              </Col>
            </Row>
            {/* Jitter Buffer Settings */}
            {(
              <>
                <Row className="mb-3 d-flex justify-content-center align-items-center">
                  <Col className="d-flex">
                    <Label title={'Jitter Buffer Type'}>Jitter Buffer Type</Label>
                    <sup>
                      <InfoPopup id={'jitterBufferType'} text='Jitter Buffer Type' />
                    </sup>
                  </Col>
                  <Col className="d-flex align-items-center justify-content-center">
                    <Toggle
                      left="Fixed"
                      right="Adaptive"
                      name="JitterBufferType"
                      value={JitterBufferType === 'Adaptive'}
                      disabled={isReadOnly}
                      onToggle={() => setJitterBufferType(JitterBufferType === 'Fixed' ? 'Adaptive' : 'Fixed')} />
                  </Col>
                  <Col>
                    <Label className="d-flex align-items-center justify-content-center">
                      {extraConfigValues?.JitterBufferType}
                    </Label>
                  </Col>
                </Row>
                <Row className="mb-3 d-flex justify-content-center align-items-center">
                  <Col className="d-flex">
                    <Label title={'Jitter min value'}>Jitter Min Value</Label>
                    <sup>
                      <InfoPopup id={'jitterMinValue'} text='Jitter Min Value' />
                    </sup>
                  </Col>
                  <Col className="d-flex align-items-center justify-content-center">
                    <Input
                      disabled={isLoading || isReadOnly}
                      name={'JitterMinDelay'}
                      value={JitterMinDelay}
                      onChange={ev => setJitterMinDelay(ev.target.value)}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                      } } />
                  </Col>
                  <Col>
                    <Label className="d-flex align-items-center justify-content-center">
                      {extraConfigValues?.JitterMinDelay}
                    </Label>
                  </Col>
                </Row>
                <Row className="mb-3 d-flex justify-content-center align-items-center">
                  <Col className="d-flex">
                    <Label title={'Jitter max value'}>Jitter Max Value</Label>
                    <sup>
                      <InfoPopup id={'jitterMaxValue'} text='Jitter Max Value' />
                    </sup>
                  </Col>
                  <Col className="d-flex align-items-center justify-content-center">
                    <Input
                      disabled={isLoading || isReadOnly}
                      name={'JitterMaxDelay'}
                      value={JitterMaxDelay}
                      onChange={ev => setJitterMaxDelay(ev.target.value)}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                      } } />
                  </Col>
                  <Col>
                    <Label className="d-flex align-items-center justify-content-center">
                      {extraConfigValues?.JitterMaxDelay}
                    </Label>
                  </Col>
                </Row>
              </>
            )}
          </>
        ) : (
          // Default Mode - Show all settings except VAD and Jitter Buffer
          <>
            <Row className="mb-2">
              <Col />
              <Col>
                <h1 className="font-weight-bold">{templateConfig ? ' New Port Settings' : "Database Settings"}</h1>
              </Col>
              <Col>
                <h1 className="font-weight-bold">{templateConfig ? 'Installed Port Settings' : "Port Settings"}</h1>
              </Col>
            </Row>
            {data?.map((item, ind) => {
          console.log('item name', item.name);

          const deviceSettingsValue = (item?.name === 'RingVoltage' && item?.type === 'dropdown') ?
            esceneToObiValues[item.value] || item.value : item.value;
          return (
            <Row className="mb-3 d-flex justify-content-center align-items-center">
              <Col className="d-flex">
                <Label title={item.tooltip}>{itemsName(item)}</Label>
                <sup>
                  <InfoPopup id={item?.name} text={item?.tooltip} />
                </sup>
              </Col>
              <Col className="d-flex align-items-center justify-content-center">
                {renderItem(item, ind)}
              </Col>
              <Col>
                <Label className="d-flex align-items-center justify-content-center">
                  {deviceSettingsValue}
                </Label>
              </Col>
            </Row>
          );
        })}
          {selectedPortConfigTemplate?.showInbandRouteToggle && 
            <Row className="mb-3 d-flex justify-content-center align-items-center">
              <Col className="d-flex">
                <Label title='Inband Route'>Inband Route</Label>
                <sup>
                  <InfoPopup id={'Inband'} text={'SET Inband Route enable/disable'} />
                </sup>
              </Col>
              <Col className="d-flex align-items-center justify-content-center">
                <Toggle
                  left="Disable"
                  right="Enable"
                  name="inband"
                  value={inbandRoute}
                  disabled={isReadOnly}
                  onToggle={() =>{
                    setInbandRoute(!inbandRoute)
                  }}
                />
              </Col>
              <Col>
                <Label className="d-flex align-items-center justify-content-center">
                  {inbandValueOnBox ? "Enabled" : "Disabled"}
                </Label>
              </Col>
            </Row>
            }
          {selectedPortConfigTemplate?.showTrunkSelectionToggle &&
            <Row className="mb-3 d-flex justify-content-center align-items-center">
              <Col className="d-flex">
                <Label title='SET Trunk'>Trunk</Label>
                <sup>
                  <InfoPopup id={'Trunk'} text={'SET Trunk'} />
                </sup>
              </Col>
              <Col className="d-flex align-items-center justify-content-center">
                <Input
                  disabled={isLoading || isReadOnly}
                  value={selectedTrunkOptions}
                  type="select"
                  name={'Inband Route'}
                  onChange={ev => setSelectedTrunkOptions(ev.target.value)}
                >
                  {trunkOptions.map((el, key) => (
                    <option key={key} value={el.value}>
                      {el.label}
                    </option>
                  ))}
                </Input>
              </Col>
              <Col>
                <Label className="d-flex align-items-center justify-content-center">
                  {trunkValueOnBox ? getTrunkLabel(trunkValueOnBox) : ''}
                </Label>
              </Col>
            </Row>
          }
          {(selectedPortConfigTemplate?.showModemModeToggle || isEsceneDevice) &&
            <ToggleRow
              title={'Modem Mode'}
              info={{ id: 'modemMode', text: 'Set Modem Mode' }}
              toggleName={'modemMode'}
              toggleValue={modemMode}
              disabled={isReadOnly}
              onToggleChange={(val) => {
                console.log("this is toggle changes ", val);
                setModemMode(val)
              }}
              realTimeValue={extraConfigValues?.modemMode}
            />
          }
          {(selectedPortConfigTemplate?.showT38EnableToggle || isEsceneDevice) &&
            <ToggleRow
              title={'T38 Enable'}
              info={{ id: 't38Enabled', text: 'Set T38 Enable' }}
              toggleName={'t38Enabled'}
              toggleValue={t38Enabled}
              disabled={isReadOnly}
              onToggleChange={(val) => {
                console.log("this is toggle changes ", val);
                setT38Enabled(val)
              }}
              realTimeValue={extraConfigValues?.t38Enabled}
            />
          }
          {(selectedPortConfigTemplate?.showFaxEnabledToggle || isEsceneDevice) &&

            <ToggleRow
              title={'Fax Event'}
              info={{ id: 'faxEnabled', text: 'Set Fax Event' }}
              toggleName={'faxEnabled'}
              toggleValue={faxEnabled}
              disabled={isReadOnly}
              onToggleChange={(val) => {
                console.log("this is toggle changes ", val);
                setFaxEnabled(val)
              }}
              realTimeValue={extraConfigValues?.faxEnabled}
            />
          }
          {/* {isEsceneDevice &&
            <ToggleRow
              title={'3 Way Calling'}
              info={{ id: 'wayCalling', text: 'Set 3 Way Calling' }}
              toggleName={'wayCalling'}
              toggleValue={wayCalling}
              onToggleChange={(val) => {
                set3WayCalling(val)
              }}
              realTimeValue={extraConfigValues?.ThreeWayCalling}
            />
          } */}
          </>
        )}

      </ModalBody>
      <ModalFooter className="port-config-footer">
        <div className="btn-row1">
          <Button
            color="primary"
            disabled={isLoading}
            onClick={() => {
              setIsLoading(true);
              refresh();
              setStart(true);
            }}
          >
            Refresh {count !== 10 && count !== 1 ? `in ${count}` : ''}
          </Button>
          {user?.permissionsGroup === 'Engineering' && !isReadOnly && (
            <Button
              color="primary"
              disabled={isLoading}
              onClick={copyPortSettingsToDatabase}
            >
              Copy Port Settings to Database Settings
            </Button>
          )}
          <Button
            disabled={isLoading || isReadOnly}
            color="primary"
            onClick={onApplyButton}
          >
            {loadApply ? <SpinnerCircles /> : 'Apply'}
          </Button>
        </div>
        <Button outline color="secondary" onClick={() => {
          // Clear portConfigModalSource when modal is closed without applying changes
          clearPortConfigModalSource();
          isClose();
        }}>
          Close
        </Button>
      </ModalFooter>
      <WarningModal
        isOpen={Boolean(ata)}
        onConfirm={onConfirm}
        title="Warning"
        onCancel={() => setConfirmation()}
        body={ata}
      />
    </Modal>
    <ConfirmationModal
      bodyText={'You are attempting to make changes to a device that is not currently locked for editing. To prevent conflicting changes, please lock the device before proceeding.'}
      headerText={'Device Lock Required'}
      confirmBtnText={'Lock & Edit'}
      close={'No'}
      isOpen={dcLockUpdatePopup.show}
      onCancel={() => {
        setDcLockUpdatePopup({ show: false, value: {} });
        setShowModal(isOpen);
      }}
      onConfirm={() => {
        unLockBoxButton();
        setDcLockUpdatePopup({ show: false, value: {} });
        setShowModal(isOpen);
      }}
    />
  </>
  );
};


const mapStateToProps = state => ({
  selectedPort: state.UIState.epikBoxDetails.selectedPort,
  selectedPortConfigTemplate: state.UIState.epikBoxDetails.selectedPortConfigTemplate,
  numbers: state.AppState.numbers,
  user: state.AppState.user,
  portConfigModalSource: state.UIState.epikBoxDetails.portConfigModalSource
});
const mapDispatchToProps = dispatch => ({
  setPortValues: (token, obiId, body) => dispatch(setPortValues(token, obiId, body)),
  setSilenceDetect: (token, obiId, portNum, toggle) =>
    dispatch(setSilenceDetect(token, obiId, portNum, toggle)),
  updateVad: (token, obiId, toggle, noReboot) =>
    dispatch(updateVad(token, obiId, toggle, noReboot)),
  changeAction: description => dispatch(changeAction(description)),
  getEpikBoxData: (token, boxId) => dispatch(getEpikBoxData(token, boxId)),
  selectPort: port => dispatch(selectBoxDetailsPort(port)),  
  setSelectedPortConfigTemplate: (template) => dispatch(setSelectedPortConfigTemplate(template)),
  clearPortConfigModalSource: () => dispatch(clearPortConfigModalSource()),
  setPortConfigChangesMade: (changesMade) => dispatch(setPortConfigChangesMade(changesMade)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PortConfigModal);
